export default "__VITE_ASSET__iy2q2VKB__"